import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useQualityAnalysisJob(jobId: string | null) {
  return useQuery({
    queryKey: ['quality-analysis-job', jobId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('quality_analysis_jobs')
        .select('*')
        .eq('id', jobId!)
        .single();
      if (error) throw error;
      return data;
    },
    enabled: !!jobId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'pending' || status === 'processing' ? 3000 : false;
    },
  });
}